import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import log from '../../../helpers/logger'
import { auth, getCurrentUser } from '../../../helpers/auth'
import { getTimeStamp, getUUIDV4 } from '../../../helpers/utils'
import { createD2hPublishMagazine } from '../../../services/D2hPublishMagazineService'
import { getIssueListByStatus } from '../../../services/IssueService'

function setErrorMsg(error) {
  return {
    registerError: error.message
  }
}

export default class D2hPublishMagazinePageAdd extends Component {

  constructor(props) {
    super(props);
    this.state = {

      issue_id: '',
      issue_uuid: '',
      magazine_id: '',
      magazine_uuid: '',
      title: '',
      description: '',
      book_download_url: '',
      download_success_msg_body: '',
      download_success_msg_title: '',
      notify_cover_number: '1:2:3',
      notify_when: 'NOW',
      date_created: '',
      status: 'W',
      issueItems: [],
      issueDocList: [],

      registerError: null,
      currentUser: null,
      isLoading: true
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);

    this.onDropdownSelected = this.onDropdownSelected.bind(this);
  }

  componentWillMount() {
    log.debug('componentWillMount')
  }
  async componentDidMount(){
    log.debug('componentDidMount')
    let user = await getCurrentUser();

    log.debug(user.displayName)

    this.setState({currentUser: user})
    // this.setState({owner_id: user.uid})
    // let uuidv4 = getUUIDV4()
    // this.setState({publisher_uuid: uuidv4})
    // this.setState({id_from_url: this.props.match.params.id_from_url})

    let issueDataList = await getIssueListByStatus('A')
    log.debug(issueDataList)
    let issueItems = [];
    let issueDocList = [];
    let i=0;
    issueDataList.forEach(function(doc){
      log.debug(doc.data(), doc.id)
      issueItems.push(<option key={doc.id} value={i}>{doc.data().title}</option>);
      issueDocList.push({
        issue_id: doc.id,
        issue_uuid: doc.data().issue_uuid,
        magazine_id: doc.data().magazine_id,
        magazine_uuid: doc.data().magazine_uuid,
        book_download_url: doc.data().issue_download_url === undefined ? '' : doc.data().issue_download_url,
      })
      i++
    })

    this.setState({issueItems: issueItems})
    this.setState({issueDocList: issueDocList})
    this.updateStateInfo(0)

    log.debug('all data is loaded.')
    this.setState({isLoading: false})
  }

  updateStateInfo(itemPosition){
    log.debug(itemPosition)
    log.debug(this.state.issueDocList[itemPosition])

    this.setState({
      issue_id: this.state.issueDocList[itemPosition].issue_id,
      issue_uuid: this.state.issueDocList[itemPosition].issue_uuid,
      magazine_id: this.state.issueDocList[itemPosition].magazine_id,
      magazine_uuid: this.state.issueDocList[itemPosition].magazine_uuid,
      book_download_url: this.state.issueDocList[itemPosition].book_download_url,
    })

  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;

    // bind all input to setState
    this.setState({
      [name]: value
    });
    log.debug(this.state)

  }

  onDropdownSelected(e) {
     console.log("THE VAL", e.target.value);
     //here you will see the current selected value of the select input
     this.updateStateInfo(e.target.value)
  }

  async handleSubmit(event) {
    event.preventDefault();

    let d2hpublishmagazine = {

      issue_id: this.state.issue_id ,
      issue_uuid: this.state.issue_uuid ,
      magazine_id: this.state.magazine_id ,
      magazine_uuid: this.state.magazine_uuid ,
      title: this.state.title ,
      description: this.state.description ,
      book_download_url: this.state.book_download_url ,
      download_success_msg_body: this.state.download_success_msg_body ,
      download_success_msg_title: this.state.download_success_msg_title ,
      notify_cover_number: this.state.notify_cover_number ,
      notify_when: this.state.notify_when ,
      date_created: this.state.date_created ,
      status: this.state.status ,
    }
    log.debug(d2hpublishmagazine)

    try{
      let result = await createD2hPublishMagazine(d2hpublishmagazine)
      log.debug('save success')
      // redirect to list view.
      this.props.history.push("/d2hpublishmagazine")
    }catch (err) {
      log.debug(err)
      this.setState(setErrorMsg(err))
    }

  }

  render () {

    let content;


    if (this.state.isLoading) {
      content = <div>Loading...</div>;
    } else {
      content =
      <div>
        <h4 className="page-header">
          <Link to='/d2hpublishmagazine'>D2hPublishMagazine</Link> ->
          Add
        </h4>
        <form className="form-horizontal" role="form" onSubmit={this.handleSubmit}>

          {
            this.state.registerError &&
          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <div className="alert alert-danger" role="alert">
              <span className="sr-only">Error:</span>
              &nbsp;{this.state.registerError}
              </div>
            </div>
          </div>
          }

          <div className="form-group">
            <label htmlFor="issue_id" className="col-sm-2 control-label">select issue_id:</label>
            <div className="col-sm-4">
              <select className="form-control"
                name="issue_id_select"
                // value="0"
                onChange={this.onDropdownSelected} >
                  {this.state.issueItems}
              </select>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="issue_id" className="col-sm-2 control-label">issue_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_id"
                value={this.state.issue_id}
                onChange={this.handleInputChange}
                placeholder="issue_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="issue_uuid" className="col-sm-2 control-label">issue_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="issue_uuid"
                value={this.state.issue_uuid}
                onChange={this.handleInputChange}
                placeholder="issue_uuid" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="magazine_id" className="col-sm-2 control-label">magazine_id:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_id"
                value={this.state.magazine_id}
                onChange={this.handleInputChange}
                placeholder="magazine_id" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="magazine_uuid" className="col-sm-2 control-label">magazine_uuid:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="magazine_uuid"
                value={this.state.magazine_uuid}
                onChange={this.handleInputChange}
                placeholder="magazine_uuid" readOnly/>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="book_download_url" className="col-sm-2 control-label">book_download_url:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="book_download_url"
                value={this.state.book_download_url}
                onChange={this.handleInputChange}
                placeholder="book_download_url" readOnly/>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="title" className="col-sm-2 control-label">title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="title"
                value={this.state.title}
                onChange={this.handleInputChange}
                placeholder="title" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="description" className="col-sm-2 control-label">description:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="description"
                value={this.state.description}
                onChange={this.handleInputChange}
                placeholder="description" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="download_success_msg_body" className="col-sm-2 control-label">download_success_msg_body:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="download_success_msg_body"
                value={this.state.download_success_msg_body}
                onChange={this.handleInputChange}
                placeholder="download_success_msg_body" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="download_success_msg_title" className="col-sm-2 control-label">download_success_msg_title:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="download_success_msg_title"
                value={this.state.download_success_msg_title}
                onChange={this.handleInputChange}
                placeholder="download_success_msg_title" />
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="notify_cover_number" className="col-sm-2 control-label">notify_cover_number:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="notify_cover_number"
                value={this.state.notify_cover_number}
                onChange={this.handleInputChange}
                placeholder="notify_cover_number" />
            </div>
            1:2:3
          </div>
          <div className="form-group">
            <label htmlFor="notify_when" className="col-sm-2 control-label">notify_when:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="notify_when"
                value={this.state.notify_when}
                onChange={this.handleInputChange}
                placeholder="notify_when" />
            </div>
            0-23 for hour, 0-59 for minnute; example: 0:00 คือเที่ยงคืน
หรือให้ใส่ NOW ตัวใหญ่สำหรับให้แสดงทันทีที่ download เสร็จ
          </div>
          {/* <div className="form-group">
            <label htmlFor="date_created" className="col-sm-2 control-label">date_created:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="date_created"
                value={this.state.date_created}
                onChange={this.handleInputChange}
                placeholder="date_created" />
            </div>
          </div> */}
          <div className="form-group">
            <label htmlFor="status" className="col-sm-2 control-label">status:</label>
            <div className="col-sm-4">
              <input className="form-control"
                type="text"
                name="status"
                value={this.state.status}
                onChange={this.handleInputChange}
                placeholder="status" />
            </div>
            A: ทำงานทันที W: รอแก้ไขทบทวน
          </div>

          <div className="form-group">
            <div className="col-sm-offset-2 col-sm-10">
              <button type="submit" className="btn btn-primary">Add</button>
            </div>
          </div>

        </form>
      </div>
    }


    return (
      <div>
          {content}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/D2hPublishMagazinePage/D2hPublishMagazinePageAdd.js